import { ProductType } from 'utils/constants';
import * as Yup from 'yup';

export const DEAL_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Required'),
  pipelineId: Yup.string().required('Required'),
  stageId: Yup.string().required('Required'),
  amount: Yup.number().nullable(),
  closedAt: Yup.date().nullable(),
  type: Yup.string().required('Required'),
  accountUserId: Yup.array().of(Yup.string()),
  companyId: Yup.string().nullable(),
  leadId: Yup.array().of(Yup.string()).nullable(),
  tagId: Yup.array(),
  data: Yup.array(
    Yup.object().shape({
      dataId: Yup.string(),
      value: Yup.mixed().nullable(),
      error: Yup.string().optional(),
    }),
  ).nullable(),
});

export type DEAL_FORM = Yup.InferType<typeof DEAL_SCHEMA>;

export const DEAL_MOVE_SCHEMA = DEAL_SCHEMA.pick([
  'pipelineId',
  'stageId',
]).partial();

export type DEAL_MOVE_FORM = Yup.InferType<typeof DEAL_MOVE_SCHEMA>;

export const MULTI_DEALS_EDIT_SCHEMA = DEAL_SCHEMA.pick(['tagId']).partial();

export type MULTI_DEALS_EDIT_FORM = Yup.InferType<
  typeof MULTI_DEALS_EDIT_SCHEMA
>;

export const SIMPLE_DEAL_SCHEMA = DEAL_SCHEMA.pick([
  'name',
  'pipelineId',
  'stageId',
  'amount',
  'type',
  'accountUserId',
  'tagId',
]);

export type SIMPLE_DEAL_FORM = Yup.InferType<typeof SIMPLE_DEAL_SCHEMA>;

export const PRODUCT_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Required'),
  price: Yup.number().required('Required'),
  type: Yup.string().oneOf(Object.values(ProductType)).required('Required'),
  description: Yup.string(),
});

export type PRODUCT_FORM = Yup.InferType<typeof PRODUCT_SCHEMA>;

export const INVOICE_SCHEMA = Yup.object().shape({
  leadId: Yup.string().required('Required'),
  issuedAt: Yup.date().required('Required'),
  dueAt: Yup.date().required('Required'),
  terms: Yup.string().required('Required'),
  items: Yup.array().required('Required'),
  leadNote: Yup.string().nullable(),
  accountNote: Yup.string().nullable(),
  attachments: Yup.array(),
});

export type INVOICE_FORM = Yup.InferType<typeof INVOICE_SCHEMA>;

export const SEND_INVOICE_SCHEMA = Yup.object().shape({
  from: Yup.string().required('Required'),
  to: Yup.array().of(Yup.string()).required('Required'),
  message: Yup.string().required('Required'),
  subject: Yup.string().required('Required'),
  sendCopyToUser: Yup.boolean(),
});

export type SEND_INVOICE_FORM = Yup.InferType<typeof SEND_INVOICE_SCHEMA>;

export const RECORD_PAYMENT_SCHEMA = Yup.object().shape({
  paidAt: Yup.date().required('Required'),
  amount: Yup.number().required('Required'),
  paymentMethod: Yup.string().required('Required'),
  notes: Yup.string().nullable(),
});

export type RECORD_PAYMENT_FORM = Yup.InferType<typeof RECORD_PAYMENT_SCHEMA>;

export const TASK_SCHEMA = Yup.object().shape({
  title: Yup.string().required('Required'),
  dueAt: Yup.date().required('Required'),
  type: Yup.string().required('Required'),
  priority: Yup.string().required('Required'),
  accountUserId: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Must provide at least 1 entry'),
  leadId: Yup.string().required('Required'),
  dealId: Yup.string().nullable(),
  content: Yup.string(),
  attachments: Yup.array(),
  status: Yup.string(),
  tagId: Yup.array(),
});

export type TASK_FORM = Yup.InferType<typeof TASK_SCHEMA>;

export const SIMPLE_TASK_SCHEMA = TASK_SCHEMA.pick([
  'title',
  'type',
  'priority',
  'leadId',
  'accountUserId',
  'dueAt',
  'tagId',
]);

export type SIMPLE_TASK_FORM = Yup.InferType<typeof SIMPLE_TASK_SCHEMA>;

export const TASK_ASSOCIATE_DEAL_SCHEMA = Yup.object().shape({
  pipelineId: Yup.string(),
  stageId: Yup.string(),
  dealId: Yup.string(),
});

export type TASK_ASSOCIATE_DEAL_FORM = Yup.InferType<
  typeof TASK_ASSOCIATE_DEAL_SCHEMA
>;
